module.exports = __webpack_public_path__ + "img/check-circle.5b4fcb1d.svg";